import clsx from 'clsx';
import { type TextLayoutBody, TextLayout } from '@/components/text-layout';
import type { Maybe } from '@/generated/graphql';

type HeroBasicProps = {
  title?: Maybe<string>;
  description?: Maybe<TextLayoutBody>;
  paddingBottom?: boolean;
  className?: string;
};

export const HeroBasic = ({
  title,
  description,
  paddingBottom = true,
}: HeroBasicProps) => (
  <div className="bg-gray-50">
    <div
      className={clsx([
        'container text-center',
        paddingBottom ? 'py-i' : 'pt-i',
      ])}
      data-testid="hero-basic-container"
    >
      <div className="grid grid-cols-1 md:grid-cols-6">
        <div className="col-span-1 md:col-span-4 md:col-start-2">
          <TextLayout
            heading={title}
            headingElement="h1"
            headingVariant="h2"
            headingAccent="centered"
            {...(description && { body: description })}
          />
        </div>
      </div>
    </div>
  </div>
);
